import { render } from "./PublicationsSection.vue?vue&type=template&id=11fbf69c&scoped=true"
import script from "./PublicationsSection.vue?vue&type=script&lang=js"
export * from "./PublicationsSection.vue?vue&type=script&lang=js"

import "./PublicationsSection.vue?vue&type=style&index=0&id=11fbf69c&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11fbf69c"]])

export default __exports__